import { alpha } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
const mui = {
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "8px",
      },
    },
  },
};
export default mui;
